// extracted by mini-css-extract-plugin
export default {"description":"ResendEmailConfirmationForm-module__description__Zs5Uc","email":"ResendEmailConfirmationForm-module__email__5m59u"};